import { render, staticRenderFns } from "./FormTextarea.vue?vue&type=template&id=4b47e5bc&scoped=true"
import script from "./FormTextarea.vue?vue&type=script&lang=js"
export * from "./FormTextarea.vue?vue&type=script&lang=js"
import style0 from "./FormTextarea.vue?vue&type=style&index=0&id=4b47e5bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b47e5bc",
  null
  
)

export default component.exports